module.exports = __webpack_public_path__ + "img/Apple.90becca0.svg";